export enum PisoTipo {
  TERRA = 'TERRA',
  CERAMICA = 'CERAMICA',
  LAJOTA = 'LAJOTA',
  MADEIRA = 'MADEIRA',
  CIMENTO = 'CIMENTO',
  OUTRO = 'OUTRO',
}
